"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCalculationByIdQuery = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.findCalculationByIdQuery = `
  query findCalculationById($id: String!) {
    findCalculationByID(id: $id) {
      ...calculation
    }
  }
  ${fragments_1.calculationFragments}
`;
//# sourceMappingURL=calculation.js.map